import { createAction } from '@poa/state';


export const fetchGeneralProfile = createAction('fetchGeneralProfile', id => ({ id }));
export const fetchGeneralProfileSuccess = createAction('fetchGeneralProfileSuccess', data => ({ data }));
export const fetchGeneralProfileFailed = createAction('fetchGeneralProfileFailed', () => ({}));

export const updateGeneralProfile = createAction('updateGeneralProfile', (id, data) => ({ id, data }));
export const updateGeneralProfileSuccess = createAction('updateGeneralProfileSuccess', data => ({ data }));
export const updateGeneralProfileFailed = createAction('updateGeneralProfileFailed', error => ({ error }));


export const fetchGeneralProfiles = createAction(
  'fetchGeneralProfiles',
  (
    filter_by = null,
    page = 1,
    search = null,
    isFavorite = false,
    page_size = 15,
  ) => ({ filter_by, page, search, isFavorite, page_size })
);
    

export const fetchGeneralProfilesSuccess = createAction('fetchGeneralProfilesSuccess', data => ({ data }));
export const fetchGeneralProfilesFailed = createAction('fetchGeneralProfilesFailed', () => ({}));


export const fetchGeneralProfileChildren = createAction('fetchGeneralProfileChildren', id => ({ id }));
export const fetchGeneralProfileChildrenSuccess = createAction('fetchGeneralProfileChildrenSuccess', (data, id) => ({ data, id }));
export const fetchGeneralProfileChildrenFailed = createAction('fetchGeneralProfileChildrenFailed', () => ({}));

export const setAccountFavorite = createAction('setAccountFavorite', id => ({ id }));
export const setAccountFavoriteSuccess = createAction('setAccountFavoriteSuccess', (data, id) => ({ data, id }));
export const setAccountFavoriteFailed = createAction('setAccountFavoriteFailed', () => ({}));


export const createTransfer = createAction('createTransfer', data => ({ data }));
export const createTransferSuccess = createAction('createTransferSuccess', data => ({ data }));

export const updateTransfer = createAction('updateTransfer', data => ({ data }));
export const updateTransferSuccess = createAction('updateTransferSuccess', data => ({ data }));

export const setDates = createAction('setDates', ({ startDate, endDate }) => ({ startDate, endDate }));


export const fetchGeneralReports = createAction('fetchGeneralReports', (id) => ({ id }));

export const fetchGeneralReportsSuccess = createAction('fetchGeneralReportsSuccess', data => ({
  data
}));

export const sendProfileAction = createAction('sendProfileAction', (id, action) => ({ id, action }));